/* eslint-disable import/no-unresolved */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { Context } from "@nuxt/types/app";

import countryList from "@/shared/constants/phoneCountryList.constant";

export default function (context: Context) {
  function country(iso2 = ""): Record<string, any> {
    const emptyResult = {
      iso2: "",
      name: "",
      flag: "",
    };

    if (!iso2) {
      return emptyResult;
    }

    const countryInfo = countryList.find(
      (countryItem: Record<string, any> = {}) =>
        countryItem.iso2 === iso2.toUpperCase(),
    );

    if (countryInfo) {
      return {
        iso2: countryInfo.iso2,
        name: countryInfo.name,
        flag: `flag-icon flag-icon-${(
          countryInfo.iso2 || ""
        ).toLowerCase()} flag-icon-squared flag-icon-rounded`,
      };
    } else {
      return emptyResult;
    }
  }

  return {
    country,
  };
}
